import { useState, useEffect, useCallback, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks'

import InputNumberDiwa from '../Generic/InputNumberDiwa'
import {
  removeListingsDiscountToSave,
  setListingsDiscountToSave,
  setEditSelectionValuesToListingDiscountToSave,
} from '../../Slices/Omnichannel/SubRuleSlice'
import { subRuleListingDiscount } from '../../Constants/TableConfiguration'
import { acquireLock } from 'Services/Omnichannel/LockService'

function SubRuleListingInput(props) {
  const dispatch = useAppDispatch()
  const listingsDiscountToSave = useAppSelector(state => state.present.subRule.listingsDiscountToSave)
  const editSelection = useAppSelector(state => state.present.subRule.editSelection)
  const listings = useAppSelector(state => state.present.configuration.allPricelists)
  const listingInformation = listings.find(x => x.name === props.channel)
  const isListingTypeSell = listingInformation && listingInformation.isSell

  const [inputActive, setInputActive] = useState(false)

  const originalChannelValue = useMemo(() => {
    if (props.recordInfo.channels && props.recordInfo.channels.length > 0) {
      const channelValue = props.recordInfo.channels.find(x => x.channel === props.channel)
      return channelValue ? channelValue[subRuleListingDiscount] : 0
    }

    return 0
  }, [props.channel, props.recordInfo])

  const valueChanged = useMemo(() => {
    return listingsDiscountToSave.find(x => x.article === props.recordInfo.key && x.channel === props.channel)
  }, [listingsDiscountToSave, props.channel, props.recordInfo])

  useEffect(() => {
    setInputActive(false)
  }, [originalChannelValue])

  const storeListingValue = useCallback(
    value => {
      const valueRounded = value || value === 0 ? Math.round(value) : value
      if (
        (originalChannelValue === valueRounded && editSelection.indexOf(props.recordInfo.key) === -1) ||
        (valueChanged && valueChanged.discount === valueRounded && editSelection.indexOf(props.recordInfo.key) === -1)
      ) {
        if (originalChannelValue === valueRounded) {
          dispatch(
            removeListingsDiscountToSave({
              article: props.recordInfo.key,
              channel: props.channel,
            }),
          )
        }
        setInputActive(false)
        return new Promise(resolve => {
          resolve(true)
        })
      }

      const result = dispatch(acquireLock(false)).then(isNotLocked => {
        if (isNotLocked) {
          dispatch(
            editSelection.length > 0 && editSelection.indexOf(props.recordInfo.key) !== -1
              ? setEditSelectionValuesToListingDiscountToSave({
                  channel: props.channel,
                  discount: valueRounded,
                })
              : setListingsDiscountToSave({
                  article: props.recordInfo.key,
                  channel: props.channel,
                  discount: valueRounded,
                }),
          )
          return isNotLocked
        }
      })

      setInputActive(false)

      return result
    },
    [dispatch, originalChannelValue, props.channel, props.recordInfo, valueChanged, editSelection],
  )

  const setEditIput = useCallback(
    e => {
      if (props.editTableDisable) {
        return
      }
      setInputActive(true)
    },
    [props.editTableDisable],
  )

  const onInputPress = useCallback(event => {
    if (event.key === 'Escape') {
      setInputActive(false)
    }
  }, [])

  return (
    <InputNumberDiwa
      className={
        valueChanged?.discount || originalChannelValue
          ? (!inputActive ? 'count-box' : 'num-input discount-input') +
            (valueChanged?.discount ? ' changed' : '') +
            (isListingTypeSell ? '' : ' sale') +
            ' bold'
          : 'count-box empty-content'
      }
      min={0}
      max={isListingTypeSell ? 100 : null}
      controls={false}
      value={valueChanged?.discount ?? originalChannelValue ?? 0}
      onValueConfirm={inputActive ? storeListingValue : null}
      onKeyDown={inputActive ? onInputPress : null}
      onFocus={setEditIput}
      readOnly={!inputActive}
    />
  )
}

export default SubRuleListingInput
